import React from 'react';
import Collapsible from 'components/atoms/Collapsible/Collapsible';
import Txt from 'components/atoms/Txt/Txt';
import classes from './CashbackDeclineReasons.module.scss';
import clsx from 'clsx';

const title = "Reasons you wouldn't receive cashback";

export type Props = {
  className?: string;
};

const CashbackDeclineReasons: React.FC<Props> = ({ className }) => {
  return (
    <Collapsible
      title={title}
      openTitle={title}
      closedTitle={title}
      className={clsx(classes.collapsibleTitle, className)}
      skipTitleTranslation
    >
      <ul className={classes.list}>
        <Txt component="li">If you cancel/return your order or part of your order.</Txt>
        <Txt component="li">
          If the brand provides offer rewards to new customers only, and you&apos;ve shopped with
          this brand before.
        </Txt>
        <Txt component="li">
          If installing an app is part of the offer, you must be a new user and cannot have
          installed the app before.
        </Txt>
        <Txt component="li">If you use a saved quote or a renewal quote to make the purchase.</Txt>
        <Txt component="li">
          If you didn&apos;t complete your order online (i.e. it was finalized over the phone).
        </Txt>
        <Txt component="li">If you used a VPN when taking part in the offer.</Txt>
        <Txt component="li">
          If you skipped a step or didn&apos;t meet the offer criteria within the given time frame.
        </Txt>
        <Txt component="li">
          If you have adblockers enabled or didn&apos;t accept all cookies with the offer/app.
        </Txt>
        <Txt component="li">
          If you have multiple accounts across other websites and completed the offer from a
          different site or installed an app that is part of the offer directly from an app store.
        </Txt>
        <Txt component="li">
          If more than one person in your household has installed the app that is part of the offer.
        </Txt>
        <Txt component="li">
          If you didn&apos;t meet the Terms and Conditions set by the brand, or the criteria of the
          Offer.
        </Txt>
      </ul>
    </Collapsible>
  );
};

export default React.memo(CashbackDeclineReasons);
